import { DOCUMENT } from '@angular/common';
import { Inject, Injectable, Injector, RendererFactory2, ViewEncapsulation } from '@angular/core';
import { Utility } from 'utility';

/** Permette la manipolazione del meta tag <link>. Copiancollato da internet */
@Injectable({
  providedIn: 'root'
})
export class LinkService {

  constructor(
    private rendererFactory: RendererFactory2,
    @Inject(DOCUMENT) private document: Document,
    private injector: Injector
  ) {
  }

  /**
   * Inject the State into the bottom of the <head>
   */
  addTag(tag: LinkDefinition): void {
    try {
      if (!tag.id) tag.id = 'id' + Utility.RandomStringDateId(5);

      const renderer = this.rendererFactory.createRenderer(this.document, {
        id: '-1',
        encapsulation: ViewEncapsulation.None,
        styles: [],
        data: {}
      });

      const link = renderer.createElement('link');
      const head = this.document.head;

      if (head === null) {
        throw new Error('<head> not found within DOCUMENT.');
      }

      Object.keys(tag).forEach((prop: string) => {
        return renderer.setAttribute(link, prop, tag[prop]);
      });

      const children = head.children;
      for (let idx = 0; idx < children.length; idx++) {
        if (children[idx].localName === 'link' && tag.id && (children[idx] as any)['id'] === tag.id) {
          renderer.removeChild(head, children[idx]);
        }
      }

      renderer.appendChild(head, link);
    } catch (e) {
      console.log(e);
    }
  }

  /** Rimuove il tag link specificato */
  public removeTag(tag: LinkDefinition): void {
    const renderer = this.rendererFactory.createRenderer(this.document, {
      id: '-1',
      encapsulation: ViewEncapsulation.None,
      styles: [],
      data: {}
    });

    const link = renderer.createElement('link');
    const head = this.document.head;

    if (head === null) {
      throw new Error('<head> not found within DOCUMENT.');
    }

    Object.keys(tag).forEach((prop: string) => {
      return renderer.setAttribute(link, prop, tag[prop]);
    });
    const children = head.children;
    // tslint:disable-next-line: prefer-for-of
    for (let idx = 0; idx < children.length; idx++) {
      if (children[idx].localName === 'link' && (children[idx] as any)['id'] === tag.id) {
        renderer.removeChild(head, children[idx]);
      }
    }
  }
  private _parseSelector(tag: LinkDefinition): string {
    // Possibly re-work this
    const attr: string = tag.rel ? 'rel' : 'hreflang';
    return `${attr}="${tag[attr]}"`;
  }
}

/** contenuto del meta tag <link> */
export declare type LinkDefinition = {
  charset?: string;
  crossorigin?: string;
  href?: string;
  hreflang?: string;
  media?: string;
  rel?: string;
  rev?: string;
  sizes?: string;
  target?: string;
  type?: string;
  id?: string;
} & {
  [prop: string]: string;
};
